import {createRouter, createWebHistory} from 'vue-router'

import HomeView from '../views/HomeView.vue'
import LoginView from '@/views/usuarios/LoginView.vue'
import PrimeiroAcesso from '@/views/usuarios/PrimeiroAcesso.vue'
import LoginCrm from '@/views/crm/LoginCrm.vue'
import ListaClientes from '@/views/clientes/ListaClientes.vue'
import ListaCorretores from '@/views/corretores/ListaCorretores.vue'
import ListaFornecedores from '@/views/fornecedores/ListaFornecedores.vue'
import ListaImoveis from '@/views/imoveis/ListaImoveis.vue'
import ListaUser from '@/views/usuarios/ListaUser.vue'
import ListaEmpresas from '@/views/empresas/ListaEmpresas.vue'
import ListaEtapas from '@/views/etapas/ListaEtapas.vue'
import ListaMateriais from '@/views/materiais/ListaMateriais.vue'
import ListaModelos from '@/views/modelos/ListaModelos.vue'
import ListaModeloEtapas from '@/views/modelos/modelo_etapas/ListaModeloEtapas.vue'
import ListaConstrucoes from '@/views/construcoes/ListaConstrucoes.vue'
import ListaConstrucaoEtapas from "@/views/construcoes/construcao_etapas/ListaConstrucaoEtapas.vue";
import ListaAnalises from "@/views/analises/ListaAnalises.vue";
import ListaCompras from "@/views/compras/ListaCompras.vue";
import ListaSaidas from "@/views/saidas/ListaSaidas.vue";
import ListaServicos from "@/views/servicos/ListaServicos.vue";
import ListaCrm from "@/views/crm/ListaCrm.vue";
import ListaAuditoria from "@/views/auditoria/ListaAuditoria.vue";
import RelatorioAnalise from "@/views/analises/RelatorioAnalise.vue";
import RelatorioCliente from "@/views/clientes/RelatorioCliente.vue";
import BaseRelatorio from "@/components/base/BaseRelatorio.vue";
import RelatorioCompras from "@/views/compras/RelatorioCompras.vue";
import RelatorioCorretor from "@/views/corretores/RelatorioCorretor.vue";
import RelatorioFornecedor from "@/views/fornecedores/RelatorioFornecedor.vue";
import RelatorioConstrucoes from "@/views/construcoes/RelatorioConstrucoes.vue";
import PdfRelatorio from "@/views/construcoes/PdfRelatorio.vue";
import {toastMessage} from "@/utils/appInstance";

const routes = [
    {
        path: '/primeiro-acesso',
        name: 'primeiro_acesso',
        component: PrimeiroAcesso,
    },

    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {requiredAuth: true},
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    // SRC
    //Auditoria
    {
        path: '/auditoria',
        name: 'auditoria',
        component: ListaAuditoria,
        meta: {requiredAuth: true, staffOnly: true},

    },
    // Cadastros
    {
        path: '/clientes',
        name: 'clientes',
        component: ListaClientes,
        meta: {requiredAuth: true},
    },
    {
        path: '/corretores',
        name: 'corretores',
        component: ListaCorretores,
        meta: {requiredAuth: true},
    },
    {
        path: '/fornecedores',
        name: 'fornecedores',
        component: ListaFornecedores,
        meta: {requiredAuth: true},
    },
    {
        path: '/imoveis',
        name: 'imoveis',
        component: ListaImoveis,
        meta: {requiredAuth: true},
    },
    {
        path: '/admin/usuarios',
        name: 'admin_usuarios',
        component: ListaUser,
        meta: {requiredAuth: true, superuserOnly: true},
    },
    {
        path: '/usuarios',
        name: 'usuarios',
        component: ListaUser,
        meta: {requiredAuth: true},
    },
    {
        path: '/empresas',
        name: 'empresas',
        component: ListaEmpresas,
        meta: {requiredAuth: true, superuserOnly: true },
    },
    {
        path: '/servicos',
        name: 'servicos',
        component: ListaServicos,
        meta: {requiredAuth: true},
    },
    // Modelos
    {
        path: '/modelos',
        name: 'modelos',
        component: ListaModelos,
        meta: {requiredAuth: true},
    },
    {
        path: '/modelo_etapas',
        name: 'modelo_etapas',
        component: ListaModeloEtapas,
        meta: {requiredAuth: true},
        props: true

    },
    {
        path: '/etapas',
        name: 'etapas',
        component: ListaEtapas,
        meta: {requiredAuth: true},
    },
    {
        path: '/materiais',
        name: 'materiais',
        component: ListaMateriais,
        meta: {requiredAuth: true},
    },
    // Construcoes
    {
        path: '/construcoes',
        name: 'construcoes',
        component: ListaConstrucoes,
        meta: {requiredAuth: true},
    },
    {
        path: '/construcao_etapas',
        name: 'construcao_etapas',
        component: ListaConstrucaoEtapas,
        meta: {requiredAuth: true},
        props: true

    },
    // Operações
    {
        path: '/analises',
        name: 'analises',
        component: ListaAnalises,
        meta: {requiredAuth: true}
    },
    {
        path: '/compras',
        name: 'compras',
        component: ListaCompras,
        meta: {requiredAuth: true}
    },
    {
        path: '/saidas',
        name: 'saidas',
        component: ListaSaidas,
        meta: {requiredAuth: true}
    },
    // Relatórios
    {
        path: '/relatorio',
        name: 'baseRelatorio',
        component: BaseRelatorio,
        meta: {requiredAuth: true}
    },
    {
        path: '/construcoes/listrelatorio',
        name: 'construcoesPdfRelatorio',
        component: PdfRelatorio,
        meta: {requiredAuth: true}
    },
    {
        path: '/analises/relatorios',
        name: 'analiseRelatorios',
        component: RelatorioAnalise,
        meta: {requiredAuth: true}
    },
    {
        path: '/clientes/relatorios',
        name: 'clienteRelatorios',
        component: RelatorioCliente,
        meta: {requiredAuth: true}
    },
    {
        path: '/compras/relatorios',
        name: 'compraRelatorios',
        component: RelatorioCompras,
        meta: {requiredAuth: true}
    },
    {
        path: '/corretores/relatorios',
        name: 'corretoresRelatorios',
        component: RelatorioCorretor,
        meta: {requiredAuth: true}
    },
    {
        path: '/fornecedores/relatorios',
        name: 'fornecedoresRelatorios',
        component: RelatorioFornecedor,
        meta: {requiredAuth: true}
    },
    {
        path: '/construcoes/relatorios',
        name: 'construcoesRelatorios',
        component: RelatorioConstrucoes,
        meta: {requiredAuth: true}
    },
    // CRM
    {
        path: '/crm/login',
        name: 'crm',
        component: LoginCrm,
    },
    {
        path: '/crm/solicitacoes',
        name: 'solicitacoes',
        component: ListaCrm,
        meta: {crmAccess: true}
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const clienteLogado = localStorage.getItem('crm_clienteLogado') === 'true';
    const isAuthenticated = localStorage.getItem('admin_isAuthenticated') === 'true';
    const isSuperUser = localStorage.getItem('admin_isSuperUser') === 'true';
    const isStaff = localStorage.getItem('admin_isStaff') === 'true';

    const primeiroAcesso = localStorage.getItem('admin_primeiroAcesso') === 'true';
    
    // Bloqueia acesso se for o primeiro acesso, exceto para a página de primeiro acesso
    if (isAuthenticated && primeiroAcesso && to.path !== '/primeiro-acesso') {
        next({ path: '/primeiro-acesso' });
        toastMessage("warn", "Atenção", "Você precisa alterar sua senha inicial para continuar.");
        return;
    }

    // Verifica se a rota exige autenticação
    if (to.matched.some(record => record.meta.requiredAuth)) {
        if (!isAuthenticated) {
            next({ path: '/login' });
            if (from.name) {
                toastMessage("warn", "Atenção", "Acesso restrito. Faça login para continuar.");
            }
        } else if (to.matched.some(record => record.meta.superuserOnly) && !isSuperUser) {
            next({ path: '/'});
            toastMessage("warn", "Atenção", "Acesso restrito a Super Usuários.");
        } else if (to.matched.some(record => record.meta.staffOnly) && !isStaff) {
            next({ path: '/'});
            toastMessage("warn", "Atenção", "Acesso restrito a Administradores.");
        } else {
            next();
        }
    }
    // Rotas acessíveis por usuário OU cliente logado (ex: CRM)
    else if (to.matched.some(record => record.meta.crmAccess)) {
        if (clienteLogado || localStorage.getItem('crm_isAuthenticated') === 'true' || isAuthenticated) {
            next();
        } else {
            next({
                path: '/crm/login',
                query: {message: 'Acesso restrito ao CRM. Faça login para continuar.'},
            });
            toastMessage("warn", "Atenção", "Acesso restrito ao CRM. Faça login para continuar.");
        }
    }

    // Rotas públicas
    else {
        next();
    }
});

export default router
